const EN = {
    title: 'Emails',
    actions: 'Modify Email',
    table: {
        title: 'Emails',
        columns: {
            id: 'Id',
            email: 'Email',
            created_at: 'Creation Date',
            updated_at: 'Modification Date',
            status: 'Status',
        },
        status: {
            3: 'Active',
            2: 'Inactive',
            title: 'Status'
        },
    },
    inputs: {
        modify: 'New Email',
        placeholder: 'Enter a new email',
    },
    alert: {
        info: {
            title: 'We sent an email to ',
            description: 'The client has 24 hours to log in and complete the verification requested there'
        },
        warning: {
            title1: 'The email ',
            title2: ' is not available to be used by this client',
            description: 'Please request another email'
        }
    }
};

export default EN;
